export default "__VITE_ASSET__4f57240e__"